module.exports = __webpack_public_path__ + "57ce65737511d05c8ea5bf5e50b41659.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/plus.svg
// module id = kv8w
// module chunks = 0